module.exports = __webpack_public_path__ + "static/media/pyramids.65d3314f.svg";